import { FC } from 'react';
import { ProductCardProps } from '../../types';
import CardBodyBottomInfo from './card-body-bottom-info';
import CardBodyPrice from './card-body-price';
import CardBodyProductName from './card-body-product-name';
import CardBodyTopTag from './card-body-top-tag';
import ProductClaimedPriority from './product-claimed-priority';

const CardBodyVerticalItemLine: FC<Partial<ProductCardProps>> = props => {
  return (
    <div role="group" className="mx-2.5 my-1.5">
      <CardBodyPrice {...props} className="mt-0" />

      <ProductClaimedPriority {...props} />

      <div>
        <CardBodyProductName {...props} className="pb-1.5" />
        <CardBodyTopTag {...props} />
      </div>

      <CardBodyBottomInfo {...props} />
    </div>
  );
};
export default CardBodyVerticalItemLine;
